/* ==========================================
   WOMEN CHECKOUT NOTICE POPUP
========================================== */

(() => {
  'use strict';

  const POPUP_ID = 'WomenCheckoutNotice';
  const CHECKOUT_SELECTOR = '#CartDrawer-Checkout';

  let allowCheckout = false;

  function createPopup() {
    if (document.getElementById(POPUP_ID)) return;

    const popup = document.createElement('div');

    popup.id = POPUP_ID;
    popup.className = 'women-checkout-popup';
    popup.setAttribute('aria-hidden', 'true');

    popup.innerHTML = `
      <div
        class="women-checkout-popup__overlay"
        data-women-popup-close
      ></div>

      <div
        class="women-checkout-popup__box"
        role="dialog"
        aria-modal="true"
        aria-labelledby="WomenCheckoutNoticeTitle"
        aria-describedby="WomenCheckoutNoticeText"
      >
        <button
          type="button"
          class="women-checkout-popup__close"
          data-women-popup-close
          aria-label="إغلاق"
        >
          ×
        </button>

        <div
          class="women-checkout-popup__icon"
          aria-hidden="true"
        >
          !
        </div>

        <h2
          id="WomenCheckoutNoticeTitle"
          class="women-checkout-popup__title"
        >
          عملاؤنا الكرام
        </h2>

        <p
          id="WomenCheckoutNoticeText"
          class="women-checkout-popup__text"
        >
          المتجر في إجازة لمدة أسبوع.
          <br>
          لو متاح ليكي استلام الطلب في هذا التوقيت،
          تقدري تستكملي طلبك، وسيتم شحنه يوم
          <strong>الأحد القادم الموافق ٢/٨</strong>.
        </p>

        <div class="women-checkout-popup__actions">
          <button
            type="button"
            class="
              women-checkout-popup__button
              women-checkout-popup__continue
            "
            data-women-popup-continue
          >
            استكمال الطلب
          </button>

          <button
            type="button"
            class="
              women-checkout-popup__button
              women-checkout-popup__cancel
            "
            data-women-popup-close
          >
            الرجوع للسلة
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(popup);
  }

  function getPopup() {
    createPopup();
    return document.getElementById(POPUP_ID);
  }

  function openPopup() {
    const popup = getPopup();
    if (!popup) return;

    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');

    document.body.classList.add('women-checkout-popup-open');

    window.setTimeout(() => {
      popup
        .querySelector('[data-women-popup-continue]')
        ?.focus();
    }, 100);
  }

  function closePopup() {
    const popup = document.getElementById(POPUP_ID);
    if (!popup) return;

    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('women-checkout-popup-open');

    window.setTimeout(() => {
      document.querySelector(CHECKOUT_SELECTOR)?.focus();
    }, 50);
  }

  function continueToCheckout(button) {
    allowCheckout = true;

    button.disabled = true;
    button.textContent = 'جاري التحويل...';

    const checkoutButton = document.querySelector(CHECKOUT_SELECTOR);
    const checkoutForm = checkoutButton?.form;

    if (checkoutButton && checkoutForm) {
      checkoutForm.requestSubmit(checkoutButton);
      return;
    }

    window.location.assign('/checkout');
  }

  document.addEventListener(
    'click',
    (event) => {
      const checkoutButton = event.target.closest(CHECKOUT_SELECTOR);

      if (checkoutButton && !allowCheckout) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (!checkoutButton.disabled) {
          openPopup();
        }

        return;
      }

      const closeButton = event.target.closest(
        '[data-women-popup-close]'
      );

      if (closeButton) {
        event.preventDefault();
        closePopup();
        return;
      }

      const continueButton = event.target.closest(
        '[data-women-popup-continue]'
      );

      if (continueButton) {
        event.preventDefault();
        continueToCheckout(continueButton);
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const submitter = event.submitter;

      if (
        submitter?.matches?.(CHECKOUT_SELECTOR) &&
        !allowCheckout
      ) {
        event.preventDefault();
        event.stopPropagation();
        openPopup();
      }
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const popup = document.getElementById(POPUP_ID);

    if (popup?.classList.contains('is-open')) {
      closePopup();
    }
  });

  createPopup();
})();